import {Component, inject} from '@angular/core';
import {ToastService} from "../../../services/toast.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../services/auth.service";
import {PasswordConfirmationValidator} from "../../../validators/passwordConfirmationValidator";

@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  standalone: false
})
export class RegisterComponent {
  registrationCompleted: boolean = false;
  isPasswordShown: boolean = false;
  isConfirmPasswordShown: boolean = false;
  registrationForm!: FormGroup;
  registeredEmail: string = '';

  private readonly toastService = inject(ToastService);
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);

  constructor() {
    this.createForm();
  }

  createForm() {
    this.registrationForm = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['',
          [Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+"), Validators.required]],
        company: ['',
          [Validators.required]],
        password: ['',
          [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['',
          [Validators.required]],
        phone: ['',
          []]
      },
      {validator: PasswordConfirmationValidator.validatePasswordMatch('password', 'confirmPassword')});
  }

  register() {
    this.registrationForm.markAllAsTouched();
    if (this.registrationForm.invalid) {
      if (this.registrationForm.controls['confirmPassword'].errors?.['mustMatch']) {
        this.toastService.showToast('Passwords do not match.', 'error');
      } else {
        this.toastService.showToast('Please fill out all required fields.', 'error');
      }
      return;
    }
    const formValues = this.registrationForm.value;
    const body = {
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      email: formValues.email,
      phone: formValues.phone,
      companyName: formValues.company,
      location: '',
      password: formValues.password,
      confirmPassword: formValues.confirmPassword
    };
    this.registeredEmail = formValues.email;
    this.authService.registration(body)
      .then((res: any) => this.handleRegistration(res))
      .catch(() => this.toastService.showToast("Registration failed", "error"));
  }

  private handleRegistration(res: any) {
    if (res.isSuccess == false) {
      this.toastService.showToast(res.error.error, "error");
      return;
    }
    this.registrationCompleted = true;
    this.toastService.showToast('Successfully registered', 'success');
  }

  isInvalidAndTouched(controlName: string): boolean {
    const control = this.registrationForm.get(controlName);
    return control != null && control.invalid && control.touched;
  }

  toggleShowPassword() {
    this.isPasswordShown = !this.isPasswordShown;
  }

  toggleShowConfirmPassword() {
    this.isConfirmPasswordShown = !this.isConfirmPasswordShown;
  }
}
